module.exports = __webpack_public_path__ + "img/plus_bgstihuan.454a08b6.png";